module.exports = __webpack_public_path__ + "img/blaabaermuffins.4d1a273d.jpg";